module.exports = __webpack_public_path__ + "img/ac4_thumb.5c151005.jpg";